module.exports = __webpack_public_path__ + "media/images/talent/case4-icon01-ed604cf77fed50b5d8096f033a95a984.png";